module.exports = __webpack_public_path__ + "static/media/inactivePhoto.a85abf4a.png";